import { Button } from "./style";

interface ActionButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  variant?: "desktop" | "mobile";
  ariaLabel?: string;
}

export const ActionButton = ({
  onClick,
  children,
  variant = "desktop",
  ariaLabel = "botão de ação",
}: ActionButtonProps) => {
  return (
    <Button onClick={onClick} variant={variant} aria-label={ariaLabel}>
      {children}
    </Button>
  );
};
